import { hydrateRoot, createRoot } from 'react-dom/client'

import App from './App'
import Routes from './Routes'
import { getReactErrorHandlers, initializeFullStory } from './utils/fullStory'

// Sentry first, before the provider tree mounts, so a failure in a provider
// (auth, Apollo, the router) is reported too. It used to run inside Routes'
// render, after every provider had mounted (and warned on each re-render).
initializeFullStory()
const errorHandlers = getReactErrorHandlers()

/**
 * When `#redwood-app` isn't empty then it's very likely that you're using
 * prerendering. So React attaches event listeners to the existing markup
 * rather than replacing it.
 * https://react.dev/reference/react-dom/client/hydrateRoot
 */
const redwoodAppElement = document.getElementById('redwood-app')

if (!redwoodAppElement) {
  throw new Error(
    "Could not find an element with ID 'redwood-app'. Please ensure it " +
      "exists in your 'web/src/index.html' file."
  )
}

if (redwoodAppElement.children?.length > 0) {
  hydrateRoot(
    redwoodAppElement,
    <App>
      <Routes />
    </App>,
    errorHandlers
  )
} else {
  const root = createRoot(redwoodAppElement, errorHandlers)
  root.render(
    <App>
      <Routes />
    </App>
  )
}
